module.exports = __webpack_public_path__ + "img/follow-img.431e919d.png";